import { createTheme } from "@mui/material/styles";

export const MUITheme = createTheme({
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    disabled:{
      color:'rgba(0, 0, 0, 0.26)',
      background:'#E0E0E0',
      border:'rgba(0, 0, 0, 0.12)'
    },
    text: {
      primary: "#3E3C48",
      inputLabel: '#828282',
      red: "#ED1C24",
      black: '#000',
      bgBlue: '#132870',
      highRiskRed: '#CF3C32',
      yellow:'#fcb040',
      lightGreen: '#00c853',
      links: '#C5E6F4',
      icon: '#BEC2CD',
      warning:'rgb(102, 60, 0)',
      white: {
        primary: '#fff',
        secondary: '#F3f3f2',
        tertiary: '#E8F4FE',
      },
      blue:{
        primary: '#1983D9',
        secondary: '#259BEB',
        tertiary: '#136BD6'
      }, 
    },
    background: {
      gradient: 'radial-gradient(circle, rgba(79,99,196,1) 0%, rgba(21,47,158,0.8842130602240896) 100%)',
      contentPane:'radial-gradient(circle, rgba(246,246,246,0.9150253851540616) 0%, rgba(193,200,247,0.8842130602240896) 100%)',
      contentPane2:'radial-gradient(circle, rgba(193,200,247,0.7842130602240896) 0%, rgba(193,200,247,0.8842130602240896) 100%)',
      primary: '#E8F4FE',
      secondary: '#D1EAFE',
      darkBlue: '#132870',
      lightBlue: '#F3F9FE',
      btnBg: '#259BEB',
      white: '#fff',
      grey: '#F3F3F2',
      warning:'rgb(255, 244, 229)',
      infoBox:'#fff'
    },
    border: {
      primary: "#8E93A2",
      secondary: "#979797",
      tertiary: '#EFF3F9',
      white: '#fff',
      blue: '#136BD6',
      grey: '#F3F3F2',
      warning:'#ed6c02'
    },
    new:{
      border: {
        primary: "#8E93A2",
        secondary: "#979797",
        tertiary: '#EFF3F9',
        white: '#fff',
        blue: '#136BD6',
        grey: '#F3F3F2'
      },
      header:{
        primary:'#132870',
        primaryActive:'var(--sm_primary)',
      },
      text:{
        primary: "#000",
        secondary:'#fff',
        ternary:'rgba(33,48,139,1)',
        primaryHover:'var(--sm_primary)',
        inputLabel: '#828282',
        black:'#000',
        blue:'var(--sm_primary)',
        green:'#268e34',
      },
      border:{
        primary:'#E0E0E0',
        secondary:'#F00',
        onPrimary:'#022a57',
        ternary:'#132870'
      },
      background:{
        primary: 'var(--sm_primary)',
        secondary:'#fff',
        grey:'#F5F5F5',
        orange:'#f07941',
        blue:'var(--sm_primary)',
        green:'#268e34',
        red:'#bc161c',
        btn:'radial-gradient(circle, rgba(66,58,195,1) 0%, rgba(33,48,139,1) 100%)',
        page:'linear-gradient(90deg, rgba(196,195,208,1) 0%, rgba(138,138,212,1) 35%, rgba(228,228,228,1) 100%)'
      }
    }
  },
  typography: {
    fontFamily:{
      primary: "sans-serif",
      secondary: "Open Sans",
      ternary:"Poppins",
    },
    body2:{
      fontFamily: "sans-serif",
    },
    h2:{
      fontFamily: "Nunito Sans",
      fontSize: 32,
      fontWeight: 600,
      lineHeight: '32px'
    },
    h3:{
      color: '#3E3C48',
      fontFamily: "Nunito Sans",
      fontSize: 26,
      lineHeight: '32px'
    },
    h4:{
      color: '#3E3C48',
      fontFamily: "Nunito Sans",
      fontSize: 24,
      lineHeight: '32px'
    },
    body1:{
      color: '#8E93A2',
      fontFamily: "Open Sans",
      fontSize: 14,
      lineHeight: '21px'
    },
    new:{
      fontFamily:{
        primary: "sans-serif",
        secondary: "Nunito Sans"
      },
      icon:{
        color:'var(--sm_primary)'
      }
    }
  }, 
});

export default MUITheme;
